<template>
  <modal :title="description" :show="showModal" @close="cancel()">
    <div class="action" slot="action">
      <div class="buttons flex center">
        <a
          @click="accept()"
          class="button secondary medium"
          :class="{ unusual: unusual == 'accept' }"
        >
          <span v-if="confirmtext">{{ confirmtext }}</span>
          <span v-else>Sim</span>
        </a>
        <a
          @click="cancel()"
          class="button primary medium"
          :class="{ unusual: unusual == 'cancel' }"
        >
          Não
        </a>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "./Modal";

export default {
  name: "modal-confirm",
  props: {
    confirmtext: String,
    description: {
      required: true,
    },
    show: {
      required: true,
      default: false,
    },
    unusual: {
      required: false,
      default: "accept",
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    show(value) {
      this.showModal = value;
    },
  },
  mounted() {
    this.showModal = this.show;
  },
  methods: {
    accept() {
      this.$emit("accept", true);
    },
    cancel() {
      this.$emit("cancel", true);
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  margin-top: 30px;
  .buttons {
    a {
      margin-right: 16px;
    }
  }
}
</style>
